import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { MongoDbDataset } from 'app/model/dataset/mongo-db.dataset';

@Metamodel.model({
    name: 'MongoDbSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(MongoDbDataset) }
})
export class MongoDbCopySource extends TabularCopySource {
}
